export { default as ContentfulAssetLink } from './contentfulAssetLink'



// WEBPACK FOOTER //
// ./src/modules/contentful/assetLink/index.js